import {
  Routes,
  Route,
  Outlet
} from "react-router-dom";
import { 
  AuthProvider,
  AuthStatus,
  RequireAuth
} from "./components/AuthProvider";
import { DashboardView } from "./components/DashboardView";
import { LoginView } from "./components/LoginView";

import "./scss/App.scss";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<RouterAuthStatusVerify />}>
          <Route
            path="/"
            element={
              <DashboardView />
            }
          />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

function RouterAuthStatusVerify() {
  return (
    <div>
      <AuthStatus />
      <Outlet />
    </div>
  );
}